<div class="project-grid">
  <project-thumbnail
    *ngFor="let project of projects; trackBy: trackByProjectId"
    [project]="project"
    [userRoles]="userRoles"
    [cardMetrics]="cardMetricsById && cardMetricsById[project.ProjectId]"
    [metricsLoading]="isMetricsPlaceholder(project.ProjectId)"
    layout="grid"
    (favoriteToggled)="favoriteToggled.emit($event)">
  </project-thumbnail>
</div>
